'use strict'

const GetFileTypeRenderers = (fileTypes, fileTypeId) => {
  const fileType = fileTypes.find(fileType => fileType.id === fileTypeId)

  return fileType ? fileType.renderers : []
}

export default GetFileTypeRenderers
